import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProfileType } from 'enums';

import { user } from 'interfaces/User.interface';

export interface UserReducerState {
  user: user | undefined;
}

const initialState: UserReducerState = {
  user: undefined,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<user>) => {
      const user = action.payload;

      let userToSet = { ...user };

      if (user.user_profiles.length === 1) {
        const firstUserProfile = user.user_profiles[0];

        userToSet = {
          ...user,
          currentProfile: firstUserProfile.dealer_org_id,
          profile_type: firstUserProfile.profile_type,
          selectedDealer:
            firstUserProfile.profile_type === ProfileType.DEALER
              ? {
                  dealer: firstUserProfile.dealer_org_id,
                  name: firstUserProfile.profile_name,
                  image: user.selectedDealer?.image,
                }
              : null,
        };
      }

      state.user = userToSet;
    },

    removeUser: () => initialState,

    changeProfile: (
      state,
      action: PayloadAction<
        Partial<
          Pick<
            user,
            | 'role'
            | 'role_name'
            | 'currentProfile'
            | 'profile_type'
            | 'selectedOrg'
            | 'selectedDealer'
          >
        >
      >,
    ) => {
      if (state.user) {
        state.user = {
          ...state.user,
          ...action.payload,
        };
      }
    },

    updateSelectedOrg: (
      state,
      action: PayloadAction<Partial<user['selectedOrg']>>,
    ) => {
      if (!state.user) return;

      if (!action.payload) {
        state.user.selectedOrg = null;
        return;
      }

      if (state.user.profile_type === ProfileType.ORGANIZATION) {
        const siteId = action.payload.selectedSite?.site;
        const siteData = state.user.sites?.find((s) => s.site_id === siteId);

        state.user.role = siteData?.role_id ?? '';
        state.user.role_name = siteData?.role_name ?? '';
      }

      state.user.selectedOrg = {
        ...(state.user.selectedOrg ?? {}),
        ...action.payload,
      } as user['selectedOrg'];
    },
  },
});

export const { setUser, removeUser, changeProfile, updateSelectedOrg } =
  userSlice.actions;

export default userSlice.reducer;
